import IAction from "../store/IAction"
import InitState from "../store/initState"
import ITeamVm from "../models/shared/ITeamVm"
import * as ITeamVmInstance from "../models/shared/ITeamVm"
import { Dispatch } from "../../node_modules/redux"
import Api from "../services/api"
import i18n from "../i18n/i18n"
import * as  metaReducer from "./metaReducer"
import * as  applicationsReducer from "./applicationsReducer"
import { Guid } from "guid-typescript"

const ADD_TEAM = "BAT2/teams/ADD_TEAM"
const REMOVE_TEAM = "BAT2/teams/REMOVE_TEAM"
const REPLACE_TEAM = "BAT2/teams/REPLACE_TEAM"
const REPLACE_TEAMS = "BAT2/teams/REPLACE_TEAMS"

export default function teamsReducer(state: ITeamVm[] = new InitState().teams, action: IAction): ITeamVm[] {
    switch (action.type) {
        case ADD_TEAM:
            return [...state, action.payload]
        case REMOVE_TEAM:
            return [...state].filter(x => x.id !== action.payload)
        case REPLACE_TEAMS:
            return [...action.payload]
        case REPLACE_TEAM:
            return [...state].map((team) => {
                if (team.id !== (action.payload as ITeamVm).id) {
                    return team
                }
                return {
                    ...team,
                    ...action.payload
                }
            })
        default:
            return state
    }
}

export function createTeam(name: string, applicationId?: string) {
    return async (dispatch: Dispatch<any>) => {
        const newTeam: ITeamVm = {
            ...ITeamVmInstance.empty(),
            id: Math.random().toString(),
            isActive: true,
            name
        }

        const result = await Api.educationalInstitution.createOrUpdateTeam(newTeam)

        if (!!result.name) {
            dispatch(metaReducer.addToastr({
                message: i18n.t("Hold oprettet"),
                type: "success"
            }))

            // Update list of teams with the newly created team
            dispatch({ type: ADD_TEAM, payload: result })

            // Set new team as selectedTeam on application, if applicationId is provided
            if (!!applicationId) {
                dispatch(applicationsReducer.updateSelectedTeam(result, applicationId))
            }

            // Set selectedTeam in meta to empty
            dispatch(metaReducer.setSelectedTeam(ITeamVmInstance.empty()))
        }
    }
}

export function removeTeam(team: ITeamVm) {
    return async (dispatch: Dispatch<any>, getState: () => InitState) => {
        const teamToRemove = team
        teamToRemove.isActive = false

        const result = await Api.educationalInstitution.createOrUpdateTeam(teamToRemove)

        if (!!result.id && Guid.isGuid(result.id) && result.isActive === false) {
            dispatch(metaReducer.addToastr({
                message: i18n.t("Hold fjernet"),
                type: "success"
            }))

            // Remove team from list
            dispatch({ type: REMOVE_TEAM, payload: result.id })
            dispatch(metaReducer.setSelectedTeam(ITeamVmInstance.empty()))
        }
    }
}

export function updateTeam(updatedTeam: ITeamVm) {
    return async (dispatch: Dispatch<any>, getState: () => InitState) => {

        const result = await Api.educationalInstitution.createOrUpdateTeam(updatedTeam)

        if (!!result.id && Guid.isGuid(result.id) && updatedTeam.name === result.name) {
            dispatch(metaReducer.addToastr({
                message: i18n.t("Hold opdateret"),
                type: "success"
            }))

            // Replace team
            dispatch({ type: REPLACE_TEAM, payload: result })
            dispatch(metaReducer.setSelectedTeam(ITeamVmInstance.empty()))
        }
    }
}